export default __webpack_public_path__ + "static/media/The Kruks Photography-558.874f02a4.jpg";